@if (cartService.isCartDrawerOpen()) {
  <div class="cart-backdrop" (click)="cartService.closeCart()"></div>
}

<div 
  class="cart-drawer" 
  role="dialog"
  aria-modal="true"
  aria-labelledby="cart-title"
  [attr.aria-hidden]="!cartService.isCartDrawerOpen()"
  [class.open]="cartService.isCartDrawerOpen()">
  
    <header class="cart-header">
      <h2 id="cart-title">
        Tu Carrito
        <span class="cart-header__count">
          {{ cartService.itemCount() }}
        </span>
      </h2>

      <button
        type="button"
        class="btn-icon-close"
        (click)="cartService.closeCart()"
        aria-label="Cerrar carrito">
        ✕
      </button>
    </header>

  <div class="cart-items-container">
    @if (cartService.cartItems().length === 0) {
      <div class="empty-state">
        <p>Tu carrito está vacío.</p>
        <button class="btn btn-outline" (click)="cartService.closeCart()">Seguir comprando</button>
      </div>
    } @else {
      
      @for (item of cartService.cartItems(); track item.id) {
        <div class="cart-item">
          <div class="item-image">
            <img [src]="item.imageUrl" [alt]="item.name" loading="lazy" decoding="async">
          </div>

          <div class="item-details">
            <h3 class="item-name">{{ item.name }}</h3>
            
            <div class="item-variants">
              @if (item.variant.keychainName) {
                <span class="variant-badge">"{{ item.variant.keychainName }}"</span>
              }
              @if (item.variant.thicknessLabel) {
                <span class="variant-badge">{{ item.variant.thicknessLabel }}</span>
              }
              @if (item.variant.keychainVariant) {
                <span class="variant-badge">{{ keychainVariantLabel(item.variant.keychainVariant) }}</span>
              }
              @if (item.variant.keychainColorName) {
                <span class="variant-badge">{{ item.variant.keychainColorName }}</span>
              }
              @if (item.variant.keychainFrontColorName) {
                <span class="variant-badge">Frente: {{ item.variant.keychainFrontColorName }}</span>
              }
              @if (item.variant.keychainBackColorName) {
                <span class="variant-badge">Detrás: {{ item.variant.keychainBackColorName }}</span>
              }
              @if (item.variant.sizeLabel) {
                <span class="variant-badge">{{ item.variant.sizeLabel }}</span>
              }
              @if (item.variant.colorHex) {
                <span class="color-dot" [style.background]="item.variant.colorHex"></span>
              }
            </div>

            <span class="item-price">{{ item.unitPrice | clpCurrency }} CLP</span>

            <div class="item-actions">
              <app-quantity-selector 
                [quantity]="item.quantity"
                (quantityChange)="cartService.updateQuantity(item.id, $event)">
              </app-quantity-selector>
              
              <button 
                type="button"
                class="btn-remove"
                (click)="cartService.removeFromCart(item.id)"
                [attr.aria-label]="'Eliminar ' + item.name + ' del carrito'">
                <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
              </button>
            </div>
          </div>

          @if (isAtMaxUnits(item)) {
            <app-max-units-notice class="item-limit-notice" [productName]="item.name" />
          }
        </div>
      }
    }
  </div>

  <div class="cart-footer">
    @if (cartService.cartItems().length > 0) {
      <div class="cart-shipping-estimate">
        @if (itemNamesWithoutDelivery().length > 0) {
          <span>Envío: solo retiro en tienda ({{ itemNamesWithoutDelivery().join(', ') }} no tiene envío)</span>
        } @else {
          <span>Envío:</span>
          <span>se calcula en el checkout según tu comuna</span>
        }
      </div>
    }
    <div class="cart-total">
      <span>Total Estimado:</span>
      <span class="total-amount">{{ cartService.cartTotal() | clpCurrency }} CLP</span>
    </div>
    <button
      class="btn-checkout"
      type="button"
      [disabled]="cartService.cartItems().length === 0"
      [attr.aria-disabled]="cartService.cartItems().length === 0"
      (click)="goToCheckout()"
    >
      <span>Ir a pagar</span>
      <span class="btn-checkout-arrow" aria-hidden="true">→</span>
    </button>
  </div>
</div>
